"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @typedef {import('react-native').PressableProps} PressableProps
 */

/**
 * InlinePressable is an alternative to React Native's Pressable that works better when nested
 * inline inside Text. It accepts the same props as React Native's Pressable.
 *
 * On Web it simply passes its props to Pressable and defaults to `inline-flex` instead of `flex`.
 *
 * @param {PressableProps} PressableProps
 */const InlinePressable = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    inlineFlex = true,
    style,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
    ref: ref,
    style: pressState => [typeof style === 'function' ? style(pressState) : style, staticStyles[inlineFlex ? 'inlineFlex' : 'inline']],
    ...props,
    children: pressState => typeof children === 'function' ? children(pressState) : children
  });
});
InlinePressable.displayName = 'InlinePressable';
InlinePressable.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  inlineFlex: _propTypes.default.bool,
  style: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array, _propTypes.default.func])
};
const staticStyles = _StyleSheet.default.create({
  inline: {
    // Stop Pressable defaulting to (block) flex
    display: 'inline'
  },
  inlineFlex: {
    display: 'inline-flex'
  }
});
var _default = exports.default = InlinePressable;